<template>
  <div id="marathon_videoCollectionPlayerIndex" v-show="currThemeObj">
    <div class="select_area">
      <marathon_select_opt
        :currThemeObj="currThemeObj"
        :data="selectOptData"
        :inputObject="select_opt_inputObject"
        :progressObject="select_opt_progressObject"
        @changeSelectEvent="changeSelect"
        @inputValEvent="inputValHandler"
      ></marathon_select_opt>
    </div>
    <div class="teamTable">
      <div class="tableScrollArea" ref="tableParentDom">
        <nodeTree_table
          :currThemeObj="currThemeObj"
          :currCid="currCid"
          :currSid="currSid"
          :tableMode="tableMode"
          :parentWidthPx="parentWidthPx"
          :isScrollFlag="isScrollFlag"
          :variableColWidthVw="variableColWidthVw"
          :tableCellDefaultWidthVw="tableCellDefaultWidthVw"
          :defaultWidthVwNum="defaultWidthVwNum"
          :tableColumnData="tableColumnData"
          :tableData="tableData"
          :tableHeightPx="tableHeightPx"
          @clickColumnEvent="clickColumn"
          :expandKey="expandKey"
          @toParentEvent="toParentEventHandler"
          v-show="tableData && tableData.length > 0"
        ></nodeTree_table>
        <p class="loadingClass" v-show="loading">加载中...</p>
        <p class="noMoreClass" v-show="noMore">没有更多了</p>
        <p class="noDataClass" v-show="noData">暂无数据</p>
      </div>
    </div>
    <Popup
      v-if="popupShow"
      :closeEvent="closePopup"
      :popTitle="popTitle"
      :popOpraBtns="popOpraBtns"
      :contentWidth="contentWidth"
    >
      <template #webmaster_popup>
        <!-- 合成锦集 -->
        <div class="group_popup" v-if="popState === 'singleSynthesis'">
          <div class="group_popup_delete_wraning">
            您确定合成
            <span v-text="popupDynameVal ? popupDynameVal : ''"></span>
            的锦集吗？
          </div>
        </div>
        <!-- 发布锦集 -->
        <div class="group_popup" v-if="popState === 'singlePublish'">
          <div class="group_popup_delete_wraning">
            您确定发布
            <span v-text="popupDynameVal ? popupDynameVal : ''"></span>
            的锦集吗？
          </div>
        </div>
        <!-- 是否禁用 -->
        <div class="group_popup" v-if="popState === 'singleDisabled'">
          <div class="group_popup_delete_wraning">
            您确定要
            <span v-text="popupDynameVal ? popupDynameVal : ''"></span>
            吗？
          </div>
        </div>
        <!-- 切片视频 -->
        <div class="group_popup" v-if="popState === 'singleVideo'">
          <!-- <div class="group_popup_delete_tit" v-text="`${popupDynameVal}`"></div> -->
          <div class="group_popup_video_box">
            <videoAliplayerV2
              :options="{ source: popupObjData.highlightObject }"
            />
          </div>
        </div>
      </template>
    </Popup>
  </div>
</template>

<script>
import {
  https_marathon_playerCollectionList,
  https_marathon_videoTemplateList,
  https_marathon_stageteammenu,
  https_marathon_playerSingleSynthesis,
  https_marathon_playerSinglePublish,
  https_marathon_playerSingleDisable,
  https_marathon_matchTemplateCollectionRate,
  https_marathon_matchTemplateCollection,
  https_marathon_matchTemplatePublish,
} from '@api/platfrom_marathon_api'
import Popup from '@components/base/base_popup.vue'
import marathon_select_opt from '@components/platfromBase/marathon/select_opt.vue'
// 表格中不需要跳转页面
import nodeTree_table from '@components/platfromBase/marathon/nodeTree_table.vue'
import videoAliplayerV2 from '@components/base/video_aliplayer_v2.vue'
import cup_base_data_mixin from '@mixins/cup_base_data'
export default {
  name: 'marathon_videoCollectionPlayerIndex',
  components: {
    marathon_select_opt,
    nodeTree_table,
    Popup,
    videoAliplayerV2,
  },
  mixins: [cup_base_data_mixin],
  data() {
    return {
      select_opt_inputObject: {
        inputTitle: '快速查询',
        placeholder: '请输入运动员名称',
        iconType: 'search',
      }, //控制marathon_select_opt中的输入框是否显示
      select_opt_progressObject: null,
      isScrollBottom: false,
      loading: false,
      tableMode: 'marathonPlayerCollectionData',
      parentWidthPx: 0,
      parentHeightPx: 0,
      isScrollFlag: false,
      isClickFlag: false,
      variableColWidthVw: 18.06,
      tableCellDefaultWidthVw: 5.55,
      defaultWidthVwNum: null,
      tableColumnData: [],
      tableData: null,
      tableTotal: 0,
      expandKey: 'isExpand',
      currStageMarathon: '-1',
      pnum: 1,
      psize: 20,
      marathonTypeArr: [],
      videoTemplateArr: [],
      actArr: [],
      selectOptData: {
        configArr: [
          {
            type: 'marathonType',
            title: '赛事类型',
            origin_keyVal: ['value', 'name'],
            dataName: 'marathonTypeArr',
          },
          {
            type: 'videoTemplate',
            title: '视频模版',
            origin_keyVal: ['value', 'name'],
            dataName: 'videoTemplateArr',
          },
        ],
        selectOpt_list: [],
      },
      contentWidth: '48%',
      popupShow: false,
      popTitle: '添加摄像机位',
      popState: '',
      popupObjData: {},
      popOpraBtns: [],
      warningText: '',
      popupDynameVal: '',
      popupObj_keyArr: [
        {
          name: '运动员：',
          key: 'athleteName',
          isRequest: false,
          isShowText: true,
          type: 'Text',
          ceil: '',
        },
        {
          name: '切片机位：',
          key: 'streamName',
          isRequest: false,
          isShowText: true,
          type: 'Text',
          ceil: '',
        },
        {
          name: '偏移时间',
          key: 'clipOffset',
          isRequest: true,
          isShowText: true,
          type: 'Time',
          ceil: '秒',
        },
      ],
    }
  },
  beforeCreate() {},
  created() {
    // this.parentHeightPx = this.$refs.tableParentDom.offsetHeight
    this.init()
    this.select_opt_progressObject = {
      btnArr: [
        {
          key: 1,
          name: '合成锦集',
          clickEvent: this.popupMatchTemplateCollectionHanlder,
        },
        {
          key: 2,
          name: '发布锦集',
          clickEvent: this.popupMatchTemplatePublishHanlder,
        },
      ],
      percentage: 0, //(0-100)
      progressColor: this.currThemeObj.cssStyle.mainColor6,
      currBtnKey: 1, //btnArr中某个元素的key值
    }
  },
  beforeDestroy() {
    this.clearTimeoutProgessHandler()
    window.removeEventListener('resize', () => {
      this.onResizeEvent()
    })
  },
  computed: {
    noMore() {
      const curTableDataNum = this.tableData ? this.tableData.length : -1
      return (
        curTableDataNum >= this.tableTotal &&
        this.tableTotal !== 0 &&
        this.isScrollBottom
      )
    },
    noData() {
      return (
        this.tableTotal === 0 && this.tableData && this.tableData.length === 0
      )
    },
    tableHeightPx() {
      let clientHeight = window.innerHeight
        ? window.innerHeight
        : window.screen.height
        ? window.screen.height
        : 667
      let clientWidth = window.innerWidth
        ? window.innerWidth
        : window.screen.width
        ? window.screen.width
        : 375

      return Math.floor(clientHeight - (clientWidth / 100) * (42 - 26))
      // return 500
    },
  },
  methods: {
    async init() {
      window.mixtmtBase_eventBus.$emit('loadingEvent', true)
      this.initTableQuery()
      console.debug(this.currCid, this.currSid)
      await this.getstageMarathon()
      await this.getVideoTemplate()
      await this.getMatchTemplateCollectionRate()
      this.setTimeoutProgessHandler()
      await this.getPlayerCollectionList()
      console.debug(this.stageArr)
      this.computedSelectOpt(this.selectOptData.configArr)

      window.mixtmtBase_eventBus.$emit('loadingEvent', false)
    },
    // 关闭弹窗
    closePopup() {
      this.popupShow = false
      this.popupObjData = {}
      this.warningText = ''
      this.contentWidth = '48%'
    },
    toParentEventHandler(data) {
      console.debug(data)
      if (data.eventName === 'marathonPlayerCollectionData_singleSynthesis') {
        // 单个运动员的合成锦集
        this.popupSingleSynthesisHanlder(data)
      } else if (
        data.eventName === 'marathonPlayerCollectionData_singlePublish'
      ) {
        // 单个运动员的发布锦集
        this.popupSinglePublishHanlder(data)
      } else if (
        data.eventName === 'marathonPlayerCollectionData_singleDisabled'
      ) {
        // 单个运动员是否禁用
        this.popupSingleDisabledHanlder(data)
      } else if (
        data.eventName === 'marathonPlayerCollectionData_singleVideo'
      ) {
        // 查看单个运动员的视频
        this.popupSingleVideoHanlder(data)
      }
    },
    popupSingleVideoHanlder(item) {
      console.debug(item)
      this.contentWidth = '56%'
      this.popupObjData = item.data
      this.popOpraBtns = []
      this.popState = 'singleVideo'
      this.popTitle = `【${this.popupObjData.athleteName}】视频`
      this.popupShow = true
    },
    popupSingleSynthesisHanlder(item) {
      this.popupObjData = item.data
      this.popOpraBtns = [
        {
          btnTitle: '取消',
          btnEvent: this.closePopup,
          btnStyle: '',
        },
        {
          btnTitle: '确定',
          btnEvent: this.postSingleSynthesis,
          btnStyle: '',
        },
      ]
      this.popupDynameVal = `【${this.popupObjData.athleteName}】`
      this.popState = 'singleSynthesis'
      this.popTitle = '合成锦集'
      this.popupShow = true
    },
    popupSingleDisabledHanlder(item) {
      this.popupObjData = item.data
      this.popOpraBtns = [
        {
          btnTitle: '取消',
          btnEvent: this.closePopup,
          btnStyle: '',
        },
        {
          btnTitle: '确定',
          btnEvent: this.postSingleDisabled,
          btnStyle: '',
        },
      ]
      this.popupDynameVal = `${
        this.popupObjData.disabled - 0 ? '开启' : '禁用'
      }【${this.popupObjData.athleteName}】`
      this.popState = 'singleDisabled'
      this.popTitle = '提示'
      this.popupShow = true
    },
    popupSinglePublishHanlder(item) {
      this.popupObjData = item.data
      this.popOpraBtns = [
        {
          btnTitle: '取消',
          btnEvent: this.closePopup,
          btnStyle: '',
        },
        {
          btnTitle: '确定',
          btnEvent: this.postSinglePublish,
          btnStyle: '',
        },
      ]
      this.popupDynameVal = `【${this.popupObjData.athleteName}】`
      this.popState = 'singlePublish'
      this.popTitle = '发布锦集'
      this.popupShow = true
    },
    popupMatchTemplateCollectionHanlder() {
      this.popOpraBtns = [
        {
          btnTitle: '取消',
          btnEvent: this.closePopup,
          btnStyle: '',
        },
        {
          btnTitle: '确定',
          btnEvent: this.postMatchTemplateCollection,
          btnStyle: '',
        },
      ]
      this.popupDynameVal = `【当前所有运动员】`
      this.popState = 'singleSynthesis'
      this.popTitle = '合成锦集'
      this.popupShow = true
    },
    popupMatchTemplatePublishHanlder() {
      this.popOpraBtns = [
        {
          btnTitle: '取消',
          btnEvent: this.closePopup,
          btnStyle: '',
        },
        {
          btnTitle: '确定',
          btnEvent: this.postMatchTemplatePublish,
          btnStyle: '',
        },
      ]
      this.popupDynameVal = `【当前所有运动员】`
      this.popState = 'singlePublish'
      this.popTitle = '发布锦集'
      this.popupShow = true
    },
    async postSingleDisabled() {
      const item = this.popupObjData
      let params = {
        matchId: this.currSid,
        tplId: this.currVideoMode,
        athleteNum: item.athleteNum,
        postData: {
          flag: item.disabled - 0 === 0,
        },
      }
      window.mixtmtBase_eventBus.$emit('loadingEvent', true)
      await https_marathon_playerSingleDisable(
        this.axiosBaseUrl,
        this.$axios,
        params
      )
        .then((response) => {
          const res = response.data
          console.debug(res)
          if (res.status === 0) {
            console.debug('是否禁用提交成功')
            this.$message({
              showClose: true,
              message: '修改成功',
              type: 'success',
            })
            this.closePopup()
            this.initTableQuery()
            this.getPlayerCollectionList()
          } else {
            if (res.message) {
              // message：null，因此不弹出警示框（一般404 || 500的时候）；
              // message不为null的时候展示警示框；
              this.$message({
                showClose: true,
                message: res.message ? res.message : '服务器异常，请稍后再试',
                type: 'warning',
              })
            }
          }
        })
        .catch((err) => {
          console.debug(err)
        })
      window.mixtmtBase_eventBus.$emit('loadingEvent', false)
    },
    async postSingleSynthesis() {
      const item = this.popupObjData
      let params = {
        matchId: this.currSid,
        tplId: this.currVideoMode,
        athleteNum: item.athleteNum,
      }
      window.mixtmtBase_eventBus.$emit('loadingEvent', true)
      await https_marathon_playerSingleSynthesis(
        this.axiosBaseUrl,
        this.$axios,
        params
      )
        .then((response) => {
          const res = response.data
          console.debug(res)
          if (res.status === 0) {
            console.debug('已提交，正在合成中，稍后查看')
            this.$message({
              showClose: true,
              message: '已提交，正在合成中，稍后查看',
              type: 'success',
            })
            this.closePopup()
          } else {
            if (res.message) {
              // message：null，因此不弹出警示框（一般404 || 500的时候）；
              // message不为null的时候展示警示框；
              this.$message({
                showClose: true,
                message: res.message ? res.message : '服务器异常，请稍后再试',
                type: 'warning',
              })
            }
          }
        })
        .catch((err) => {
          console.debug(err)
        })
      window.mixtmtBase_eventBus.$emit('loadingEvent', false)
    },
    async postSinglePublish() {
      const item = this.popupObjData
      let params = {
        matchId: this.currSid,
        tplId: this.currVideoMode,
        athleteNum: item.athleteNum,
      }
      window.mixtmtBase_eventBus.$emit('loadingEvent', true)
      await https_marathon_playerSinglePublish(
        this.axiosBaseUrl,
        this.$axios,
        params
      )
        .then((response) => {
          const res = response.data
          console.debug(res)
          if (res.status === 0) {
            console.debug('已提交，正在发布中，稍后查看')
            this.$message({
              showClose: true,
              message: '已提交，正在发布中，稍后查看',
              type: 'success',
            })
            this.closePopup()
          } else {
            if (res.message) {
              // message：null，因此不弹出警示框（一般404 || 500的时候）；
              // message不为null的时候展示警示框；
              this.$message({
                showClose: true,
                message: res.message ? res.message : '服务器异常，请稍后再试',
                type: 'warning',
              })
            }
          }
        })
        .catch((err) => {
          console.debug(err)
        })
      window.mixtmtBase_eventBus.$emit('loadingEvent', false)
    },
    async postMatchTemplateCollection() {
      let params = {
        matchId: this.currSid,
        tplId: this.currVideoMode,
        postData: {
          code: this.currStageMarathon,
        },
      }
      window.mixtmtBase_eventBus.$emit('loadingEvent', true)
      await https_marathon_matchTemplateCollection(
        this.axiosBaseUrl,
        this.$axios,
        params
      )
        .then((response) => {
          const res = response.data
          console.debug(res)
          if (res.status === 0) {
            console.debug('已提交，正在合成中，稍后查看')
            this.$message({
              showClose: true,
              message: '已提交，正在合成中，稍后查看',
              type: 'success',
            })
            this.closePopup()
          } else {
            if (res.message) {
              // message：null，因此不弹出警示框（一般404 || 500的时候）；
              // message不为null的时候展示警示框；
              this.$message({
                showClose: true,
                message: res.message ? res.message : '服务器异常，请稍后再试',
                type: 'warning',
              })
            }
          }
        })
        .catch((err) => {
          console.debug(err)
        })
      window.mixtmtBase_eventBus.$emit('loadingEvent', false)
    },
    async postMatchTemplatePublish() {
      let params = {
        matchId: this.currSid,
        tplId: this.currVideoMode,
        postData: {
          code: this.currStageMarathon,
        },
      }
      window.mixtmtBase_eventBus.$emit('loadingEvent', true)
      await https_marathon_matchTemplatePublish(
        this.axiosBaseUrl,
        this.$axios,
        params
      )
        .then((response) => {
          const res = response.data
          console.debug(res)
          if (res.status === 0) {
            console.debug('已提交，正在发布中，稍后查看')
            this.$message({
              showClose: true,
              message: '已提交，正在发布中，稍后查看',
              type: 'success',
            })
            this.closePopup()
          } else {
            if (res.message) {
              // message：null，因此不弹出警示框（一般404 || 500的时候）；
              // message不为null的时候展示警示框；
              this.$message({
                showClose: true,
                message: res.message ? res.message : '服务器异常，请稍后再试',
                type: 'warning',
              })
            }
          }
        })
        .catch((err) => {
          console.debug(err)
        })
      window.mixtmtBase_eventBus.$emit('loadingEvent', false)
    },
    async getMatchTemplateCollectionRate() {
      let params = {
        matchId: this.currSid,
        tplId: this.currVideoMode,
        code: this.currStageMarathon,
      }
      let rate = this.select_opt_progressObject.percentage
      await https_marathon_matchTemplateCollectionRate(
        this.axiosBaseUrl,
        this.$axios,
        params
      )
        .then((response) => {
          if (response) {
            const res = response.data
            if (res.status === 0) {
              console.debug(res)
              rate =
                res.data.rate == 1 ? 100 : (res.data.rate * 100).toFixed(2) * 1

              let select_opt_progressObject = this.select_opt_progressObject
              select_opt_progressObject.percentage = rate
              this.select_opt_progressObject = select_opt_progressObject
            }
          }
        })
        .catch((err) => {
          console.debug(err)
          if (err.message) {
            // message：null，因此不弹出警示框（一般404 || 500的时候）；
            // message不为null的时候展示警示框；
            this.$message({
              showClose: true,
              message: err.message ? err.message : '服务器异常，请稍后再试',
              type: 'warning',
            })
          }
        })
      if (this.setTimeoutId) {
        this.setTimeoutProgessHandler()
      }
    },
    setTimeoutProgessHandler() {
      this.setTimeoutId = window.setTimeout(() => {
        this.getMatchTemplateCollectionRate()
      }, 10 * 1000)
    },
    clearTimeoutProgessHandler() {
      if (this.setTimeoutId) {
        window.clearTimeout(this.setTimeoutId)
        this.setTimeoutId = null
      }
    },
    inputValHandler(inputVal) {
      // 获取inputVal值
      console.debug('inputVal:', inputVal)
      this.curInputVal = inputVal
      this.initTableQuery()
      this.getPlayerCollectionList()
    },
    initScroll() {
      if (this.tableDom) {
        return
      }
      this.parentWidthPx = this.$refs.tableParentDom.offsetWidth
      console.debug(
        'this.parentWidthPx:',
        this.$refs.tableParentDom.scrollHeight
      )
      this.beforeScrollTop = 0
      this.threshold = 5
      this.DIRECTION_ENUM = {
        DOWN: 'down',
        UP: 'up',
      }
      window.addEventListener('resize', () => {
        this.onResizeEvent()
      })
      this.tableDom = document.getElementsByClassName(
        'el-table__body-wrapper'
      )[0]
      this.tableDom.addEventListener('scroll', () => {
        const scrollTop = this.tableDom.scrollTop
        const scrollHeight = this.tableDom.scrollHeight
        const parentHeightPx = this.tableDom.offsetHeight
        let direction = this.DIRECTION_ENUM.DOWN
        if (this.beforeScrollTop > scrollTop) {
          direction = this.DIRECTION_ENUM.UP
        }
        // 通过滚动方向判断是触底还是触顶
        console.debug(
          'direction:',
          direction,
          scrollTop,
          parentHeightPx,
          scrollHeight,
          this.isScrollBottom
        )
        if (direction == this.DIRECTION_ENUM.DOWN) {
          // 滚动触底
          if (scrollTop + parentHeightPx + this.threshold >= scrollHeight) {
            console.debug('滚动触底')
            this.load()
            if (this.pnum > this.allPages) {
              this.isScrollBottom = true
            }
          }
        } else {
          // 滚动到顶部
          this.isScrollBottom = false
          if (scrollTop <= this.threshold) {
            console.debug('滚动到顶部')
          }
        }
        this.beforeScrollTop = this.tableDom.scrollTop
      })
    },
    onResizeEvent() {
      if (this.$refs.tableParentDom) {
        this.parentWidthPx = this.$refs.tableParentDom.offsetWidth
      } else {
        console.debug('dom 不存在')
      }
    },
    computedSelectOpt(configArr, type) {
      // 组装选择框数据
      let selectOpt_list = []
      configArr.forEach((config, index) => {
        let disabledArr = []
        const mix_id = `mix_${config.origin_keyVal[0]}`
        console.debug(config.dataName, this[config.dataName])
        let list = this[config.dataName].map((item) => {
          item[mix_id] = `${config.type}_${item[config.origin_keyVal[0]]}`
          return item
        })
        if (type) {
          selectOpt_list = this.selectOptData.selectOpt_list
          if (config.type === type) {
            selectOpt_list.forEach((item) => {
              if (item.type === type) {
                item.list = list
                item.curId = list[0] ? list[0][mix_id] : ''
                item.curVal = list[0] ? list[0][config.origin_keyVal[1]] : ''
              }
            })
          }
        } else {
          selectOpt_list.push({
            type: config.type,
            title: config.title,
            keyVal: [mix_id, config.origin_keyVal[1]],
            curId: list[0] ? list[0][mix_id] : '', // 选中的id,是改装后的，需要去掉前缀才是源数据的唯一id
            curVal: list[0] ? list[0][config.origin_keyVal[1]] : '', // 这个值是源数据需要展示的值，没有做过修改
            disabledArr, //当【阶段】选择为淘汰赛时，球队这栏置灰；所以在【球队】这组对象的disabledArr=['stage_2']；而【阶段】的disabledArr = []。在marathon_select_opt组件中也需要做一些逻辑处理，主要是对curStageVal这个值
            list,
          })
        }
      })

      this.selectOptData.selectOpt_list = selectOpt_list
      console.debug('this.selectOptData.selectOpt_list', selectOpt_list)
    },
    async changeSelect(data) {
      console.debug(data)
      let valPathArr = []
      let val = data.val
      // 选择后，重置联动的筛选框
      // let updateSelectIndex = -1
      if (data.type === 'select') {
        if (val.indexOf('_') > -1) {
          valPathArr = val.split('_')
          for (let i = 0; i < this.selectOptData.selectOpt_list.length; i++) {
            let item = this.selectOptData.selectOpt_list[i]
            const idKey = item.keyVal[0]
            const valKey = item.keyVal[1]
            if (item.type == valPathArr[0]) {
              for (let j = 0; j < item.list.length; j++) {
                let cell = item.list[j]
                console.debug(idKey, val)
                if (cell[idKey] == val) {
                  console.debug(cell[idKey], val)
                  // updateSelectIndex = i
                  item.curVal = cell[valKey]
                  break
                }
              }
            }
          }
          if (valPathArr[0] === 'marathonType') {
            this.currStageMarathon = valPathArr[1]
            await this.getVideoTemplate()
            this.computedSelectOpt(
              this.selectOptData.configArr,
              'videoTemplate'
            )
            // console.debug("selectOpt_list:", this.selectOptData.selectOpt_list)
          } else if (valPathArr[0] === 'videoTemplate') {
            this.currVideoMode = valPathArr[1]
          } else {
          }
          // 筛选表格逻辑
          this.initTableQuery()
          this.tableColumnData = []
          this.clearTimeoutProgessHandler()
          await this.getMatchTemplateCollectionRate()
          this.setTimeoutProgessHandler()
          await this.getPlayerCollectionList()
        } else {
          console.debug('id命名方式不符合组件规则')
        }
      } else {
        console.debug('data.type 没有匹配成功')
      }
    },
    load() {
      console.debug('load')
      if (this.pnum > this.allPages || this.loading) {
        return
      }
      this.loading = true
      this.getPlayerCollectionList()
    },
    clickColumn(prop) {
      console.debug(prop)
      this.initTableQuery()
      this.getPlayerCollectionList()
    },
    initTableQuery() {
      this.pnum = 1
    },
    async getstageMarathon() {
      await https_marathon_stageteammenu(this.axiosBaseUrl, this.$axios)
        .then((response) => {
          const res = response.data
          if (res.status === 0) {
            this.marathonTypeArr = res.data ? res.data : []
            this.currStageMarathon = res.data[0] ? res.data[0].value : ''
          } else {
            if (res.message) {
              // message：null，因此不弹出警示框（一般404 || 500的时候）；
              // message不为null的时候展示警示框；
              this.$message({
                showClose: true,
                message: res.message ? res.message : '服务器异常，请稍后再试',
                type: 'warning',
              })
            }
          }
        })
        .catch((err) => {
          console.debug(err)
        })
    },
    async getVideoTemplate() {
      let params = {
        matchId: this.currSid,
        code: this.currStageMarathon,
      }
      await https_marathon_videoTemplateList(
        this.axiosBaseUrl,
        this.$axios,
        params
      )
        .then((response) => {
          const res = response.data
          if (res.status === 0) {
            this.videoTemplateArr = res.data
              ? res.data.map((item) => {
                  return {
                    value: item.templateId,
                    name: item.templateName,
                  }
                })
              : []
            if (this.videoTemplateArr.length > 0) {
              this.currVideoMode = this.videoTemplateArr[0].value
            }
          } else {
            if (res.message) {
              // message：null，因此不弹出警示框（一般404 || 500的时候）；
              // message不为null的时候展示警示框；
              this.$message({
                showClose: true,
                message: res.message ? res.message : '服务器异常，请稍后再试',
                type: 'warning',
              })
            }
          }
        })
        .catch((err) => {
          console.debug(err)
        })
    },
    async getPlayerCollectionList() {
      await https_marathon_playerCollectionList(
        this.axiosBaseUrl,
        this.$axios,
        {
          matchId: this.currSid,
          tplId: this.currVideoMode ? this.currVideoMode : '',
          code: this.currStageMarathon ? this.currStageMarathon : '',
          athleteName: this.curInputVal ? this.curInputVal : '',
          page: this.pnum,
          pageSize: this.psize,
        }
      )
        .then((response) => {
          const res = response.data
          if (res.status === 0) {
            if (res.data) {
              this.tableTotal = res.data.total
              this.allPages = res.data.pageSize
              const columns = [
                {
                  colKey: 'rankNum',
                  colTitle: '排名',
                },
                {
                  colKey: 'athleteName',
                  colTitle: '球员名称',
                },
                {
                  colKey: 'playerLogo',
                  colTitle: '球员头像',
                },
                {
                  colKey: 'gunTime',
                  colTitle: '枪时成绩',
                },
                {
                  colKey: 'netTime',
                  colTitle: '净成绩',
                },
                {
                  colKey: 'avgPace',
                  colTitle: '平均配速(min/km)',
                },
                {
                  colKey: 'operateArr',
                  colTitle: '操作',
                },
                {
                  colKey: 'collectionArr',
                  colTitle: '锦集',
                },
              ]
              const fristColumns = columns.slice(0, 3)
              const otherColumns = columns.slice(3)
              // this.defaultWidthVwNum = otherColumns.length - 1 //减去这一列isExpand
              if (this.tableColumnData.length == 0) {
                let tableColumnData = []
                let fristColumnPropArr = []
                for (let i = 0; i < fristColumns.length; i++) {
                  fristColumnPropArr.push(fristColumns[i].colKey)
                }
                const fristColumn = {
                  prop: 'rankNum-playerLogo-playerName-shirtNumber-sex', //fristColumnPropArr.join('-'),
                  label: '运动员',
                  widthVw: this.variableColWidthVw, //对应列的宽度，单位vw
                  className: 'columnNumLogoNameClass', //单独定制的头部样式class
                  // fixed: 'left', //是否锁定，如果开启不滚动，此字段无效
                }

                tableColumnData.push(fristColumn)
                for (let i = 0; i < otherColumns.length; i++) {
                  const item = otherColumns[i]
                  tableColumnData.push({
                    prop: item.colKey,
                    label: item.colTitle,
                    widthVw: this.tableCellDefaultWidthVw, //单独设置 isExpand 的对应列的宽度，单位vw
                    className: '', //单独定制的头部样式class
                    selected: '',
                  })
                }
                // console.debug('res.data：',res.data)
                this.tableColumnData = tableColumnData
              }
              if (this.pnum == 1) {
                this.tableData = res.data.list
                  ? res.data.list.map((val) => {
                      this.actArr.forEach((item) => {
                        if (item.code == val.isActive) {
                          val.isActiveName = item.name
                        }
                      })
                      val.rankNum = ''
                      val.genderName = val.gender
                      val.playerLogo = val.profilePicture
                      return val
                    })
                  : []
                // this.$refs.tableParentDom.scrollTo(0, 0)
                this.initScroll()
              } else {
                let indexNo =
                  this.tableData && this.tableData.length > 0
                    ? this.tableData.length
                    : 0
                this.tableData = this.tableData.concat(
                  res.data
                    ? res.data.list.map((val) => {
                        this.actArr.forEach((item) => {
                          if (item.code == val.isActive) {
                            val.isActiveName = item.name
                          }
                        })
                        val.rankNum = ''
                        val.genderName = val.gender
                        val.playerLogo = val.profilePicture
                        return val
                      })
                    : []
                )
              }
            } else {
              console.debug('暂无数据')
            }
            console.debug(
              '暂无数据:',
              this.tableTotal,
              this.tableData,
              this.tableData.length
            )
            if (this.tableTotal >= this.tableData.length) {
              if (this.tableTotal === 0) {
                this.tableData = []
              } else {
                if (this.pnum !== 1) {
                  this.$nextTick(() => {
                    this.loading = false
                  })
                } else {
                  this.$nextTick(() => {
                    this.loading = false
                    if (
                      this.$refs.tableParentDom.offsetHeight <
                      Math.floor(this.tableHeightPx)
                    ) {
                      this.isScrollBottom = true
                    }
                    console.debug(
                      'getParentHeightPx:',
                      this.$refs.tableParentDom.offsetHeight,
                      this.tableHeightPx
                    )
                  })
                }
                this.pnum++
              }
            }
          } else {
            if (res.message) {
              // message：null，因此不弹出警示框（一般404 || 500的时候）；
              // message不为null的时候展示警示框；
              this.$message({
                showClose: true,
                message: res.message ? res.message : '服务器异常，请稍后再试',
                type: 'warning',
              })
            }
          }
        })
        .catch((err) => {
          console.debug(err)
        })
    },
  },
}
</script>

<style lang="scss" scoped>
#marathon_videoCollectionPlayerIndex {
  .select_area {
    position: relative;
    padding-top: 2.778vw;
    width: 100%;
    height: 9.028vw;
    .switch_area {
      position: absolute;
      top: 2.778vw;
      right: 0;
      z-index: 10;
    }
  }

  .teamTable {
    padding: 2.778vw 0 6.964vw;
    .tableScrollArea {
      position: relative;
    }
  }

  .loadingClass,
  .noMoreClass,
  .noDataClass {
    position: absolute;
    bottom: -4.166vw;
    left: 0;
    z-index: 2;
    width: 100%;
    line-height: 4.166vw;
    text-align: center;
    font-size: 0.972vw;
    color: var(--mixtmt_greyColor2);
  }
  .noDataClass {
    border-top: 1px solid var(--mixtmt_greyColor0);
    border-bottom: 1px solid var(--mixtmt_greyColor0);
  }

  .group_popup {
    height: 100%;
    padding: 0.694vw;
    width: 90%;
    h1 {
      font-size: 1.25vw;
      color: var(--mixtmt_greyColor3);
    }
    .group_popup_row {
      margin-bottom: 1.388vw;
      display: flex;
      display: -webkit-flex;
      justify-content: space-between;
      align-items: center;
      &.alignItemsStart {
        align-items: flex-start;
      }
      .row_right_item {
        flex: 1;
        display: flex;
        display: -webkit-flex;
        justify-content: flex-start;
        align-items: center;
        &.flexColumn {
          flex-direction: column;
          align-items: flex-start;
        }
        .ceil {
          padding-left: 0.694vw;
          font-size: 0.972vw;
          font-weight: 600;
          color: var(--mixtmt_greyColor2);
        }
      }
      & > span {
        width: 8.333vw;
        padding-right: 0.694vw;
        text-align: right;
        font-size: 0.972vw;
        font-weight: 600;
        color: var(--mixtmt_greyColor2);
      }
    }
    .group_popup_warning {
      display: flex;
      display: -webkit-flex;
      justify-content: flex-start;
      align-items: center;
      width: 100%;
      height: 1.25vw;
      font-size: 0.8333vw;
      font-weight: 400;
      color: var(--mixtmt_errColor);
      line-height: 1.25vw;
      margin: 0.694vw 0;
    }
    .group_popup_btns {
      text-align: center;
      &:after {
        content: '';
        clear: both;
      }
    }
    .group_popup_cancel,
    .group_popup_save {
      display: inline-block;
      width: 8.333vw;
      height: 1.94vw;
      background: rgba(255, 255, 255, 1);
      border-radius: 0.138vw;
      border: 1px solid rgba(220, 223, 230, 1);
      font-size: 0.833vw;
      font-weight: 500;
      color: rgba(90, 94, 102, 1);
      line-height: 1.94vw;
      cursor: pointer;
    }
    .group_popup_save {
      margin-left: 1.388vw;
      background: var(--mixtmt_mainColor6);
      color: rgba(255, 255, 255, 1);
      border: none;
      &:hover {
        background: var(--mixtmt_mainColor6);
      }
    }
    .group_popup_cancel {
      &:hover {
        border: 1px solid var(--mixtmt_mainColor6);
      }
    }
    // 删除弹框样式
    .group_popup_delete_tit {
      font-size: 0.972vw;
      font-weight: 600;
      color: var(--mixtmt_greyColor2);
      line-height: 1.25vw;
      text-align: center;
    }
    .group_popup_delete_wraning {
      margin: 1.388vw 0;
      font-size: 0.972vw;
      font-weight: 600;
      color: var(--mixtmt_greyColor2);
      line-height: 1.667vw;
      text-align: center;
      span {
        color: var(--mixtmt_errColor);
      }
    }
    .group_popup_video_box {
      position: relative;
      width: 100%;
      height: calc(60vh - 8.333vw - 2.778vw);
    }
  }
}
</style>
